export const sectionToYearToString = sectionToYear => {
  return sectionToYear.sectionName + ' (' + sectionToYear.schoolYearName + ')'
}
